module.exports = function(successCallback, errorCallback) {
	require.ensure([], function() {
		successCallback(require("!!../node_modules/babel-loader/lib/index.js!./PageNotFound.js"));
	}, function() {
		if (errorCallback) errorCallback.apply(this, arguments);
	});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/split-chunk-loader?lazy!./src/PageNotFound.js
// module id = 1242
// module chunks = 58